module.exports = __webpack_public_path__ + "static/fonts/iconfont.8681eeca.woff2";